import { useAuth } from '@/src/context/AuthContext';
import { useTheme } from '@/src/context/ThemeContext';
import { useTranslation } from '@/src/i18n';
import { ForgotPasswordScreen } from '@/src/presentation/screens/ForgotPasswordScreen';
import { useRouter } from 'expo-router';
import { useState } from 'react';
import { platformAlert } from '@/src/core/utils/platformAlert';

export default function ForgotPasswordContainer() {
  const router = useRouter();
  const { colors } = useTheme();
  const { t } = useTranslation();
  const { resetPassword } = useAuth();
  const [email, setEmail] = useState('');
  const [loading, setLoading] = useState(false);

  const handleResetPassword = async () => {
    if (!email.trim()) {
      platformAlert(t('common.error'), t('alerts.enterEmail'));
      return;
    }

    try {
      setLoading(true);
      const { error } = await resetPassword(email.trim());

      if (error) {
        const isRateLimitError = (err: any) =>
          err?.status === 429 || /after \d+ seconds/i.test(err?.message ?? '');
        let msg: string;
        if (error.name === 'AuthRetryableFetchError') {
          msg = t('errors.networkError');
        } else if (isRateLimitError(error)) {
          msg = t('errors.rateLimitAuth');
        } else {
          msg = error.message || t('errors.somethingWentWrong');
        }
        platformAlert(t('common.error'), msg);
      } else {
        platformAlert(t('common.success'), t('auth.checkEmail'), [
          { text: t('common.ok'), onPress: () => router.back() },
        ]);
      }
    } catch (error: any) {
      platformAlert(t('common.error'), error.message || t('errors.somethingWentWrong'));
    } finally {
      setLoading(false);
    }
  };

  return (
    <ForgotPasswordScreen
      email={email}
      setEmail={setEmail}
      loading={loading}
      handleResetPassword={handleResetPassword}
      navigateBack={() => router.back()}
      colors={colors}
    />
  );
}
